<template lang='haml'>
  %v-layout.row
    %v-flex.xs12
      %h1 Affiliates
      %br
</template>

<script>
  import Events from '@/api/events'

  export default {
    data () {
      return {
        loading: false
      }
    },
    methods: {
      toggleLoader () {
        Events.$emit('toggleLoading', !this.loading)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?cabcacc6